import ClpTable from "components/ClpTable"
import { useMemo } from "react"

const ImportResult = ({ items }) => {
  const columns = useMemo(
    () => [
      {
        accessorFn: (cell) => {
          return cell.successImport ? "Importerad" : "Trasig"
        },
        header: "Importstatus"
      },
      {
        accessorFn: (cell) => {
          return cell.isValid ? "OK" : "Inte OK"
        },
        header: "Valideringstatus"
      },
      {
        accessorFn: (cell) => {
          return cell.userImportDto.namn
        },
        header: "Namn"
      },
      {
        accessorFn: (cell) => {
          return cell.userImportDto.användarnamn
        },
        header: "Användarnamn"
      },
      {
        accessorFn: (cell) => {
          return cell.generatedPassword
        },
        header: "Lösenord"
      },
      {
        accessorFn: (cell) => {
          return cell.userImportDto.skickaLoginuppgifter ? "Ja" : "Nej"
        },
        header: "Skicka inlogg per mail"
      },
      {
        accessorFn: (cell) => {
          return cell.messages.map((item) => {
            return <span>{item}; </span>
          })
        },
        header: "Meddelanden"
      }
    ],
    []
  )

  return <ClpTable rows={items} columns={columns} />
}

export default ImportResult
